import React from 'react';
import CopyrightText from "./copyright_text";

const Copyright = () => (
  <div>
    <a href="/">
      <img alt="SchoolHire" src={require('images/logo_w.png')}/>
    </a>
    <p className="copy">
      <CopyrightText/>
    </p>
  </div>
);

export default Copyright;
